import { SEARCH_SEARCH_LINE_SET_DATA } from 'rebook/apps/search/constants';


const initialState = {
  value: null,
  isActive: false,
  lastLocation: null,
  isLoading: false,
};

export default function searchQuery(state = initialState, action) {
  switch (action.type) {
    case SEARCH_SEARCH_LINE_SET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
